import React, { useState, useRef } from "react"
import {
  LoginForm,  
  ProFormCaptcha,
  ProFormCheckbox,
  ProFormText,
} from "@ant-design/pro-components"
import {  
  LockOutlined,
  MobileOutlined,  
  UserOutlined,  
} from "@ant-design/icons"
import { message, Space, Tabs } from "antd"
import queryString from "query-string"
import { post } from "@rails/request.js"
import SparkMD5 from "spark-md5"

const iconStyles = {
  marginInlineStart: "16px",
  color: "rgba(0, 0, 0, 0.2)",
  fontSize: "24px",
  verticalAlign: "middle",
  cursor: "pointer",
}

const PhoneLogin = (props) => {
  const formRef = useRef(null)
  const [loginType, setLoginType] = useState("phone")

  const passwordLogin = async (values) => {
    const user = values
    const response = await post("/users/sign_in", {
      body: JSON.stringify(user),
    })
    if (response.ok) {
      const redirectUrl = response.response?.url || "/"
      window.location.href = redirectUrl
    } else {
      message.error("用户名或者密码错误")
    }
  }

  const sendSmsCode = async () => {
    const phone = formRef?.current?.getFieldValue("phone")
    if (!phone || !/^1\d{10}$/.test(phone)) {
      message.error("请输入合法的手机号")
      throw new Error("请输入手机号")
      return
    }
    const timestamp = new Date().getTime()
    const secret = SparkMD5.hash(`phone_${phone}_${timestamp}`)
    const body = {
      phone: phone,
      timestamp: timestamp,
      secret: secret,
    }
    const response = await post("/api/user_phones/send_phone_code", {
      body: JSON.stringify(body),
    })
    if (response.ok) {
      message.success("获取验证码成功")
    } else {
      message.error("获取验证码失败，请稍后重试")
      throw new Error("获取验证码错误")
    }
  }

  const phoneLogin = async (values) => {
    const body = { phone: values.phone, phone_code: values.phone_code }
    const response = await post("/api/user_phones/phone_login", {
      body: JSON.stringify(body),
    })
    if (response.ok) {
      const parsed = queryString.parse(location.search)
      const redirectUrl = parsed?.redirect
      if (redirectUrl) {
        window.location.href = redirectUrl
      } else {
        window.location.href = "/manage"
      }
    } else {
      const responseBody = await response.json
      message.error(`${responseBody.error}，请稍后重试`)
    }
  }

  const tryLogin = async (values) => {
    if (loginType === "phone") {
      await phoneLogin(values)
    } else {
      await passwordLogin(values)
    }
  }

  return (
    <>
      <div style={{ backgroundColor: "white" }}>
        <LoginForm
          formRef={formRef}
          onFinish={async (values) => {
            await tryLogin(values)
          }}

          // actions={
          //   <Space>
          //     其他登录方式
          //     <AlipayCircleOutlined style={iconStyles}/>
          //     <TaobaoCircleOutlined style={iconStyles}/>
          //     <WeiboCircleOutlined style={iconStyles}/>
          //   </Space>
          // }
        >
          <Tabs
            centered
            activeKey={loginType}
            onChange={(activeKey) => setLoginType(activeKey)}
            items={[
              {
                key: "account",
                label: "账号密码登录",
              },
              {
                key: "phone",
                label: "手机登录",
              },
            ]}
          ></Tabs>
          {loginType === "account" && (
            <>
              <ProFormText
                name={["user", "email"]}
                fieldProps={{
                  size: "large",
                  prefix: <UserOutlined className={"prefixIcon"} />,
                }}
                initialValue={""}
                placeholder={"请输入手机号/邮箱"}
                rules={[
                  {
                    required: true,
                    message: "请输入手机号/邮箱",
                  },
                ]}
              />
              <ProFormText.Password
                name={["user", "password"]}
                fieldProps={{
                  size: "large",
                  prefix: <LockOutlined className={"prefixIcon"} />,
                }}
                placeholder={"密码"}
                rules={[
                  {
                    required: true,
                    message: "请输入密码！",
                  },
                ]}
              />
            </>
          )}
          {loginType === "phone" && (
            <>
              <ProFormText
                fieldProps={{
                  size: "large",
                  prefix: <MobileOutlined className={"prefixIcon"} />,
                }}
                name="phone"
                placeholder={"手机号"}
                rules={[
                  {
                    required: true,
                    message: "请输入手机号！",
                  },
                  {
                    pattern: /^1\d{10}$/,
                    message: "手机号格式错误！",
                  },
                ]}
              />
              <ProFormCaptcha
                fieldProps={{
                  size: "large",
                  prefix: <LockOutlined className={"prefixIcon"} />,
                }}
                captchaProps={{
                  size: "large",
                }}
                placeholder={"请输入验证码"}
                countDown={60}
                captchaTextRender={(timing, count) => {
                  if (timing) {
                    return `${count} ${"获取验证码"}`
                  }
                  return "获取验证码"
                }}
                name="phone_code"
                rules={[
                  {
                    required: true,
                    message: "请输入验证码！",
                  },
                ]}
                onGetCaptcha={async () => {
                  await sendSmsCode()
                }}
              />
            </>
          )}
          <div
            style={{
              marginBlockEnd: 24,
            }}
          >
            <ProFormCheckbox
              noStyle
              checked={true}
              name={["user", "remember_me"]}
              initialValue={true}
            >
              记住我
            </ProFormCheckbox>
          </div>
        </LoginForm>
      </div>
    </>
  )
}

export default PhoneLogin
